'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'immutable';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
const USER_AGENT_ENABLED = 'userAgentEnabled';
const ACTION_SOURCES_ENABLED = 'actionSourcesEnabled';
const SOURCE_URL_ENABLED = 'sourceUrlEnabled';
const FIRST_NAME_ENABLED = 'firstNameEnabled';
const LAST_NAME_ENABLED = 'lastNameEnabled';
const EMAIL_ENABLED = 'emailEnabled';
const PHONE_ENABLED = 'phoneEnabled';
const GENDER_ENABLED = 'genderEnabled';
const CITY_ENABLED = 'cityEnabled';
const STATE_ENABLED = 'stateEnabled';
const COUNTRY_ENABLED = 'countryEnabled';
const ZIP_CODE_ENABLED = 'zipcodeEnabled';
export const IP_ADDRESS_ENABLED = 'ipAddressEnabled';
export const REQUIRED_VISITOR_DATA = [USER_AGENT_ENABLED, ACTION_SOURCES_ENABLED, SOURCE_URL_ENABLED];
export const REQUIRED_VISITOR_DATA_WITH_IP = [USER_AGENT_ENABLED, ACTION_SOURCES_ENABLED, SOURCE_URL_ENABLED, IP_ADDRESS_ENABLED];
export const VISITOR_DATA = [USER_AGENT_ENABLED, ACTION_SOURCES_ENABLED, SOURCE_URL_ENABLED, FIRST_NAME_ENABLED, LAST_NAME_ENABLED, EMAIL_ENABLED, PHONE_ENABLED, GENDER_ENABLED, CITY_ENABLED, STATE_ENABLED, COUNTRY_ENABLED, ZIP_CODE_ENABLED, IP_ADDRESS_ENABLED];

const TooltipItem = ({
  children,
  option
}) => /*#__PURE__*/_jsx("span", {
  children: /*#__PURE__*/_jsx(UITooltip, {
    placement: "top",
    headingText: option.heading,
    title: option.tooltip,
    disabled: option.value !== IP_ADDRESS_ENABLED,
    children: children
  })
});

const getVisitorDataOptions = limitedDataUseEnabled => {
  const requiredFields = limitedDataUseEnabled ? REQUIRED_VISITOR_DATA_WITH_IP : REQUIRED_VISITOR_DATA;
  return List(VISITOR_DATA).map(item => ({
    value: item,
    text: I18n.text(`ADS_ACCOUNT_CONNECTION.conversionsApi.visitorData.${item}`),
    clearableValue: !requiredFields.includes(item),
    disabled: requiredFields.includes(item),
    heading: I18n.text('ADS_ACCOUNT_CONNECTION.conversionsApi.visitorData.tooltipHeader'),
    tooltip: I18n.text('ADS_ACCOUNT_CONNECTION.conversionsApi.visitorData.tooltipText')
  })).sortBy(item => item.text).toArray();
};

const VisitorDataSelection = ({
  defaultValue,
  onVisitorDataChange,
  limitedDataUseEnabled,
  showErrors
}) => {
  const handleChange = e => {
    onVisitorDataChange(e.target.value);
  };

  return /*#__PURE__*/_jsx(UIFormControl, {
    error: showErrors && defaultValue.length === 0,
    validationMessage: showErrors && defaultValue.length === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.validationError.dataSharing",
      "data-test-id": "data-sharing-validation-error"
    }) : null,
    children: /*#__PURE__*/_jsx(UISelect, {
      multi: true,
      anchorType: "button",
      onChange: handleChange,
      options: [{
        text: I18n.text('ADS_ACCOUNT_CONNECTION.conversionsApi.visitorData.selectAll'),
        selectAll: true,
        options: getVisitorDataOptions(limitedDataUseEnabled)
      }],
      placeholder: I18n.text('ADS_ACCOUNT_CONNECTION.conversionsApi.visitorData.placeholder'),
      defaultValue: defaultValue,
      valueComponent: TooltipItem
    })
  });
};

export default VisitorDataSelection;